import React from "react";

// Eager: first-screen for logged-in users + login screens (allowlist)
import Dashboard from "views/DashboardNew.jsx";
import Login from "views/pages/Login.jsx";
import LoginWithCaptcha from "views/pages/LoginWithCaptcha.jsx";

// Lazy: route-level code-splitting for everything else
const Video = React.lazy(() => import("views/Video.jsx"));
const Zoom = React.lazy(() => import("views/Zoom.jsx"));
const Subscription = React.lazy(() => import("views/Subscription.jsx"));
const PaymentForm = React.lazy(() => import("views/PaymentForm.jsx"));
const SubSuccess = React.lazy(() => import("views/SubSuccess.jsx"));
const material = React.lazy(() => import("views/Material.jsx"));
const prediction = React.lazy(() => import("views/Prediction.jsx"));
const Practice = React.lazy(() => import("views/Practice.jsx"));
const DailyFeedback = React.lazy(() => import("views/DailyFeedback.jsx"));
const DailyTask = React.lazy(() => import("views/DailyTask.jsx"));
const session = React.lazy(() => import("views/Session.jsx"));
const notification = React.lazy(() => import("views/Notification.jsx"));
const DailyTaskAdmin = React.lazy(() => import("views/DailyTaskAdmin.jsx"));
const QuestionList = React.lazy(() => import("views/QuestionList.jsx"));
const QuestionListWeekly = React.lazy(() => import("views/QuestionListWeekly.jsx"));

// import Test from "views/Test.jsx";
const Test = React.lazy(() => import("views/MockTest/Test"));
const SectionalTest = React.lazy(() => import("views/SectionalTests/Test"));
const FullTest = React.lazy(() => import("views/FullTest.jsx"));

const ViewPdf = React.lazy(() => import("views/ViewPdf.jsx"));
const Result = React.lazy(() => import("views/Result.jsx"));
const Score = React.lazy(() => import("views/Score.jsx"));
const ShowVideo = React.lazy(() => import("views/ShowVideo.jsx"));
const Mock = React.lazy(() => import("views/Mock.jsx"));
const PracticedDetail = React.lazy(() => import("views/PracticedDetail.jsx"));
const Template = React.lazy(() => import("views/Template.jsx"));
const Help = React.lazy(() => import("views/Help.jsx"));
const MockPending = React.lazy(() => import("views/MockPending.jsx"));
const MockResult = React.lazy(() => import("views/MockResult.jsx"));
const MockAnalysis = React.lazy(() => import("views/MockAnalysis.jsx"));
const MockAnalysis1 = React.lazy(() => import("views/MockAnalysis1.jsx"));
const Profile = React.lazy(() => import("views/Profile.jsx"));
const Transaction = React.lazy(() => import("views/Transaction.jsx"));
const ResetPassword = React.lazy(() => import("views/pages/ResetPassword.jsx"));
const Forgot = React.lazy(() => import("views/pages/Forgot.jsx"));
const Register = React.lazy(() => import("views/pages/Register.jsx"));
const Chrome = React.lazy(() => import("views/Chrome.jsx"));
const ChromeCheckGlobal = React.lazy(() => import("views/ChromeCheckGlobal.jsx"));
const Password = React.lazy(() => import("views/Password.jsx"));
const ProgressTracker = React.lazy(() => import("views/ProgressTracker.jsx"));
const NotFound = React.lazy(() => import("./page/NotFound"));
const NotFoundAdmin = React.lazy(() => import("./page/NotFoundAdmin"));
const SpeakingTestingApis = React.lazy(() => import("./views/SpeakingTestingApis"));
const PracticeHistory = React.lazy(() => import("views/PracticeHistory"));
const Unauthorized = React.lazy(() => import("views/Unauthorized"));
const PredictionFiles = React.lazy(() => import("views/PredictionFiles"));
const SubscriptionDetail = React.lazy(() => import("views/SubscriptionDetail"));
const Plans = React.lazy(() => import("page/plans"));
// import Plans from "components/Payments/SuccessCard";
const Notifications = React.lazy(() => import("page/Notifications"));
const Check = React.lazy(() => import("views/pages/Check"));
const CCA = React.lazy(() => import("views/CCA"));
const CancelComponentCCA = React.lazy(() => import("views/CCAvenue/CancelComponentCCA"));
const RedirectComponentCCA = React.lazy(() => import("views/CCAvenue/RedirectComponentCCA"));
const PaymentCard = React.lazy(() => import("components/Payments/PaymentCard"));
const WritingAssessment = React.lazy(() => import("views/WritingAssessment"));
const NewMicSetup = React.lazy(() => import("views/NewMicSetup"));
const RegisterWithCaptcha = React.lazy(() => import("views/pages/RegisterWithCaptcha"));
const SuccessCard = React.lazy(() => import("components/Payments/SuccessCard"));

let url_type =
  import.meta.env.VITE_API_URL === "https://backend22.languageacademy.com.au"
    ? 2
    : 1;

const routes = [
  // {
  //   path: "/ccav/plans",
  //   name: "cc avenue payment",
  //   type: 2,
  //   component: CCA,
  //   layout: "/admin",
  // },
  {
    path: "/payment/status",
    name: "Payment Status",
    type: 2,
    component: PaymentCard,
    layout: "/admin",
  },
  {
    path: "/cca/cancel/url",
    name: "cc avenue payment",
    type: 2,
    component: CancelComponentCCA,
    layout: "/admin",
  },
  {
    path: "/cca/redirect/url",
    name: "cc avenue payment",
    type: 2,
    component: RedirectComponentCCA,
    layout: "/admin",
  },
  {
    path: "/unauthorized",
    name: "UnAuthorized Access Restricted",
    type: 2,
    component: Unauthorized,
    layout: "/admin",
  },
  {
    path: "/testingggss",
    name: "Testing apis",
    icon: "fa fa-tachometer",
    component: SpeakingTestingApis,
    layout: "/admin",
    type: url_type,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "fa fa-tachometer",
    component: Dashboard,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/chrome",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: Chrome,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/progress/:id",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: ProgressTracker,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/allCheck",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: ChromeCheckGlobal,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/mic-setup",
    name: "Mic Setup",
    icon: "fa fa-microphone",
    component: NewMicSetup,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice-detail",
    name: "Practiced Detail",
    icon: "fa fa-user",
    component: PracticedDetail,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/profile",
    name: "My Profile",
    icon: "fa fa-user",
    component: Profile,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/subscription-detail",
    name: "Subscription Detail",
    icon: "fa fa-user",
    component: SubscriptionDetail,
    layout: "/admin",
    type: 2,
  },
  {
    collapse: true,
    name: "Pages",
    icon: "nc-icon nc-book-bookmark",
    state: "pagesCollapse",
    type: 2,
    views: [
      {
        path: "/check",
        name: "Check",
        mini: "L",
        component: Check,
        layout: "/auth",
      },
      {
        path: "/login",
        name: "Login",
        mini: "L",
        // component: Login,
        component: LoginWithCaptcha,
        layout: "/auth",
      },

      {
        path: "/register",
        name: "Register",
        mini: "R",
        component: RegisterWithCaptcha,
        layout: "/auth",
      },
      {
        path: "/forgot",
        name: "Forgot",
        mini: "R",
        component: Forgot,
        layout: "/auth",
      },
      {
        path: "/ResetPassword",
        name: "ResetPassword",
        mini: "R",
        component: ResetPassword,
        layout: "/auth",
      },
    ],
  },
  {
    path: "",
    name: "Practice Materials",
    icon: "fa fa-search",
    component: material,
    layout: "/admin",
    type: 1,
    state: "pagesCollapse",
    collapse: true,
    views: [
      {
        path: "/test-material",
        name: "Practice Questions",
        icon: "fa fa-file-text",
        component: material,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/monthly-prediction",
        name: "monthly Prediction",
        icon: "fa fa-hourglass-half",
        component: prediction,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/template",
    name: "Template",
    icon: "fa fa-clipboard",
    component: Template,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "fa fa-bell",
    component: Notifications,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/prediction-files",
    name: "Prediction",
    icon: "fa fa-clipboard",
    component: PredictionFiles,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/sectionalTest",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: SectionalTest,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/test",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Test,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/fulltest/:id/:pending",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: FullTest,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/viewpdf/:id",
    name: "ViewPdf",
    icon: "nc-icon nc-bank",
    component: ViewPdf,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/result/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Result,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/scorecard/:type/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Score,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/analysis/:type/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: MockAnalysis,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/mock-analysis/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: MockAnalysis1,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/video/:id",
    name: "video",
    icon: "nc-icon nc-bank",
    component: ShowVideo,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice/:type/:id/:index/:aType/:mark/:attempted/:complexity/:videos",
    name: "practice",
    icon: "nc-icon nc-bank",
    component: Practice,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice-hist/:type/:id/:index/:aType/:mark/:attempted/:complexity",
    name: "practice history",
    icon: "nc-icon nc-bank",
    component: PracticeHistory,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/questionList/:type/:id",
    name: "Question List",
    icon: "nc-icon nc-bank",
    component: QuestionList,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/questions-weekly/:type/:id",
    name: "Question Weekly",
    icon: "nc-icon nc-bank",
    component: QuestionListWeekly,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "Mock Test",
    icon: "fa fa-pencil-square-o",
    component: Mock,
    layout: "/admin",
    type: 1,
    state: "mockCollapse",
    collapse: true,
    views: [
      {
        path: "/mock",
        name: "Take test",
        icon: "fa fa-check",
        component: Mock,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/pending",
        name: "Pending Test",
        icon: "fa fa-star-half",
        component: MockPending,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/mock-result",
        name: "Test result",
        icon: "fa fa-line-chart",
        component: MockResult,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "",
    name: "Mock Test",
    icon: "fa fa-pencil-square-o",
    component: Mock,
    layout: "/admin",
    type: 1,
    state: "mockCollapse",
    collapse: true,
    views: [
      {
        path: "/extensive/new-sectional-tests",
        name: "New Sectional Tests (Beta)",
        icon: "fa fa-line-chart",
        component: Mock,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/extensive-pending/new-sectional-tests",
        name: "Pending Test",
        icon: "fa fa-star-half",
        component: MockPending,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/results",
        name: "Test result",
        icon: "fa fa-line-chart",
        component: MockResult,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/videos",
    name: "PTE Secret Strategy Videos",
    icon: "fa fa-youtube-play",
    component: Video,
    layout: "/admin",
    type: 1,
  },
  {
    path: "",
    name: "Daily Goals",
    icon: "fa fa-line-chart",
    component: DailyTask,
    layout: "/admin",
    type: 1,
    state: "dailyCollapse",
    collapse: true,
    views: [
      {
        path: "/daily-task",
        name: "Daily Task",
        icon: "fa fa-list-ul",
        component: DailyTask,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/success-plan",
        name: "Success Plan",
        icon: "fa fa-sticky-note-o",
        component: DailyTaskAdmin,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/daily-feedback",
        name: "Daily Feedback",
        icon: "fa fa-comments",
        component: DailyFeedback,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/session",
    name: "Live session",
    icon: "fa fa-video-camera",
    component: session,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/notification",
    name: "Notification",
    icon: "fa fa-bell",
    component: notification,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/videos",
    name: "PTE Secret Strategy Videos",
    icon: "fa fa-youtube-play",
    component: Video,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/help",
    name: "Help",
    icon: "fa fa-youtube-play",
    component: Help,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/zoom",
    name: "Zoom Meeting",
    icon: "fa fa-youtube-play",
    component: Zoom,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/transaction",
    name: "Transactions",
    icon: "fa fa-retweet",
    component: Transaction,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/subscription",
    name: "Videos",
    icon: "fa fa-youtube-play",
    component: Subscription,
    layout: "/sub",
    type: 2,
  },
  {
    path: "sub/payment/form/:id",
    name: "PaymentForm",
    icon: "fa fa-credit-card",
    component: PaymentForm,
    layout: "/admin",
    type: 2,
  },
  {
    path: "sub/success",
    name: "SubSuccess",
    icon: "fa fa-signal",
    component: SubSuccess,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/plans",
    name: "Plans",
    icon: "fa fa-signal",
    component: Plans,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/password",
    name: "Change Password",
    icon: "fa fa-signal",
    component: Password,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "",
    icon: "fa fa-user",
    component: NotFoundAdmin,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "Login",
    mini: "L",
    type: 2,
    component: NotFound,
    layout: "/auth",
  },
];

export default routes;
